// Ingredient and lot costs are stored per base unit (g, ml, each). Show them per
// kg / L so a real per-gram price never renders as £0.00.
export const fmtUnitCost = (value, unit) => {
  if (value === null || value === undefined || value === '') return '—';
  const n = typeof value === 'number' ? value : parseFloat(value);
  if (Number.isNaN(n)) return String(value);
  const u = String(unit || '').trim().toLowerCase();
  if (u === 'g') return `£${(n * 1000).toFixed(2)}/kg`;
  if (u === 'ml') return `£${(n * 1000).toFixed(2)}/L`;
  if (u === 'kg') return `£${n.toFixed(2)}/kg`;
  if (u === 'l' || u === 'litre' || u === 'liter') return `£${n.toFixed(2)}/L`;
  const precise = n !== 0 && Math.abs(n) < 0.1 ? n.toFixed(4) : n.toFixed(2);
  return u ? `£${precise}/${u}` : `£${precise}`;
};
